import { useState } from "react";
import { P, FF, inputBase } from "../../styles/tokens";
import { CATS } from "../../constants/categories";
import { Card, Heading } from "../ui";
import AccountSelect from "../inputs/AccountSelect";

function TipoToggle({ value, onChange }) {
  return (
    <div style={{ display:"flex", borderRadius:10, overflow:"hidden", border:`1.5px solid ${P.border}`, flexShrink:0 }}>
      {[{v:"fijo",label:"🏠 Fijo",t:P.fijos},{v:"extra",label:"🛍️ Extra",t:P.extras},{v:"ingreso",label:"💵 Ingreso",t:P.ingresos}].map(opt=>(
        <button key={opt.v} onClick={()=>onChange(opt.v)}
          style={{ padding:"5px 11px", border:"none", cursor:"pointer", fontFamily:FF, fontSize:11, fontWeight:opt.v===value?700:500,
            background:opt.v===value?opt.t.pastel:"transparent", color:opt.v===value?opt.t.text:P.textSm,
            borderRight:opt.v!=="ingreso"?`1.5px solid ${P.border}`:"none" }}>
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default function RecurrentesView({ recurrentes, setRecurrentes, cuentas = [] }) {
  const [confirmingId, setConfirmingId] = useState(null);
  const add=()=>setRecurrentes([...recurrentes,{id:crypto.randomUUID(),concepto:"",monto:0,cat:"",tipo:"fijo",dia_mes:null,cuenta_id:null}]);
  const upd=(id,f)=>setRecurrentes(recurrentes.map(r=>r.id===id?{...r,...f}:r));
  const del=(id)=>setRecurrentes(recurrentes.filter(r=>r.id!==id));
  return (
    <Card style={{ overflow:"hidden" }}>
      <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:6 }}>
        <span style={{ fontSize:18 }}>🔁</span>
        <Heading>Gastos recurrentes</Heading>
        <span style={{ fontSize:11, color:P.textXs, fontFamily:FF, marginLeft:"auto" }}>Auto cada mes</span>
      </div>
      {recurrentes.length===0 && <p style={{ fontSize:13, color:P.textXs, fontFamily:FF, textAlign:"center", padding:"20px 0", marginTop:-8 }}>Sin gastos recurrentes aún</p>}
      {recurrentes.map(r=>(
        <div key={r.id} style={{ padding:"12px 0", borderBottom:`1px solid ${P.border}` }}>
          {/* Línea 1: tipo + concepto */}
          <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8, flexWrap:"wrap" }}>
            <TipoToggle value={r.tipo||"fijo"} onChange={v=>upd(r.id,{tipo:v})} />
            <input aria-label="Nombre del gasto recurrente" value={r.concepto} onChange={e=>upd(r.id,{concepto:e.target.value})} placeholder="Ej: Spotify, Seguro auto…"
              style={{ flex:1, minWidth:100, border:"none", background:"transparent", color:P.text, fontSize:13, fontFamily:FF, outline:"none", fontWeight:500 }} />
            {confirmingId === r.id ? (
              <div style={{ display:"flex", gap:4, alignItems:"center", flexShrink:0 }}>
                <span style={{ fontSize:10, fontWeight:600, color:"#991B1B" }}>¿Seguro?</span>
                <button type="button" onClick={()=>{ del(r.id); setConfirmingId(null); }}
                  aria-label="Confirmar eliminar"
                  style={{ width:36, height:36, borderRadius:10, border:"1.5px solid #FECACA", background:"#FEF2F2", color:"#DC2626", fontSize:12, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>✓</button>
                <button type="button" onClick={()=>setConfirmingId(null)}
                  aria-label="Cancelar"
                  style={{ width:36, height:36, borderRadius:10, border:"1.5px solid #E5E7EB", background:"#F3F4F6", color:"#6B7280", fontSize:12, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>✕</button>
              </div>
            ) : (
              <button type="button" onClick={()=>setConfirmingId(r.id)} style={{ width:36, height:36, borderRadius:10, border:`1.5px solid ${P.border}`, background:"transparent", color:P.textXs, cursor:"pointer", fontSize:14, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>×</button>
            )}
          </div>
          <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
            {r.tipo==="extra"&&(
              <select value={r.cat||""} onChange={e=>upd(r.id,{cat:e.target.value})} style={{ ...inputBase, flex:1, fontSize:12, minWidth:100 }}>
                <option value="">Categoría…</option>
                {CATS.map(c=><option key={c} value={c}>{c}</option>)}
              </select>
            )}
            <select
              aria-label="Día del mes"
              value={r.dia_mes||""}
              onChange={e=>upd(r.id,{dia_mes:e.target.value?Number(e.target.value):null})}
              style={{ ...inputBase, width:90, fontSize:12, flexShrink:0 }}
            >
              <option value="">Día…</option>
              {Array.from({length:31},(_,i)=>i+1).map(d=>(
                <option key={d} value={d}>Día {d}</option>
              ))}
            </select>
            <div style={{ position:"relative", width:r.tipo==="extra"?120:140, flexShrink:0 }}>
              <span style={{ position:"absolute", left:10, top:"50%", transform:"translateY(-50%)", color:P.textXs, fontSize:12 }}>$</span>
              <input aria-label="Monto del gasto recurrente" type="number" inputMode="decimal" step="any" min="0" value={r.monto||""} onChange={e=>upd(r.id,{monto:Number(e.target.value)})} placeholder="0"
                style={{ ...inputBase, paddingLeft:24, fontWeight:800, color:r.tipo==="fijo"?P.fijos.text:P.extras.text }} />
            </div>
            <AccountSelect value={r.cuenta_id} onChange={v=>upd(r.id,{cuenta_id:v})} cuentas={cuentas} required />
          </div>
        </div>
      ))}
      <button onClick={add} style={{ marginTop:14, border:`1.5px dashed ${P.borderMd}`, borderRadius:10, background:"transparent", color:P.textSm, cursor:"pointer", padding:"8px 16px", fontSize:12, fontFamily:FF, fontWeight:600 }}>
        + Agregar recurrente
      </button>
    </Card>
  );
}
